import {
  ChargeSmallCard,
  ChargeSmallCardTitle,
  HelperLine,
} from "@/pages/profile/components/atom";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

export function BaseUnitPrice({
  symbol,
  cpuPrice,
  gpuPrice,
  priceUnit,
}: {
  symbol: string;
  cpuPrice: number;
  gpuPrice: number;
  priceUnit: { cpu: string; gpu: string };
}) {
  const { t } = useTranslation("profile");

  return (
    <ChargeSmallCard className="basic-unit">
      <ChargeSmallCardTitle>{t("benchmark_unit_price")}</ChargeSmallCardTitle>

      <ChargeInfo>
        <InfoArea>
          <CoreType>CPU</CoreType>
          <PriceArea>
            <span className="currency">{symbol}</span>
            <span className="price"> {cpuPrice}</span>
            <span className="unit">/{priceUnit.cpu}</span>
          </PriceArea>
        </InfoArea>

        <HelperLine height={14}></HelperLine>

        <InfoArea>
          <CoreType>GPU</CoreType>
          <PriceArea>
            <span className="currency">{symbol}</span>
            <span className="price"> {gpuPrice}</span>
            <span className="unit">/{priceUnit.gpu}</span>
          </PriceArea>
        </InfoArea>
      </ChargeInfo>
    </ChargeSmallCard>
  );
}

const ChargeInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 23px;
  margin-top: 9px;
`;

const CoreType = styled.div`
  width: 34px;
  height: 18px;
  line-height: 18px;
  font-size: 12px;
  text-align: center;
  background: #7c7d84;
  border-radius: 4px;
  color: #292b2f;
`;

const InfoArea = styled.div`
  display: flex;
  align-items: center;
`;
const PriceArea = styled.div`
  margin-left: 8px;
  height: 22px;
  line-height: 22px;
  white-space: nowrap;
  .currency {
    font-size: 10px;
  }
  .price {
    font-size: 10px;
  }
  .unit {
    font-size: 10px;
  }
`;
